<!-- TheHeader.vue -->
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import jaJP from "@/locales/ja-JP.json";
import enUS from "@/locales/en-US.json";
import LanguageChanger from "./LanguageChanger.vue";

type MessageSchema = typeof jaJP;

const { t } = useI18n<{
  message: MessageSchema
}, "ja-JP" | "en-US">({
  inheritLocale: true,
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

</script>

<template>
  <header class="app-header">
    <h1 class="app-title">
      <router-link to="/" class="title-l">{{ t("app.title") }}</router-link>
      <router-link to="/" class="title-p">
        <span>{{ t("app.title1") }}</span>
        <span>{{ t("app.title2") }}</span>
      </router-link>
    </h1>
    <LanguageChanger />
  </header>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

.app-header {
  position: sticky;
  top: 0;
  padding: 0;
  text-align: left;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)); 
  height: calc(3rem + 2px);
  z-index: 10;
}

.app-title {
  display: inline-block;
  position: relative;
  margin: 0;
  margin-left: 4rem;
  margin-top: .75rem;
  height: 100%;
  a {
    font-size: 1.5rem;
    color: #fff;
    text-decoration: none;
    @include dark-bordered-text();
  }
}

@include mq(sp) {
  .app-title {
    margin-top: .25rem;
  }
  .title-l {
    display: none;
  }
  .title-p {
    span {
      display: block;
      font-size: 1.25rem;
    }
  }
}

@include mq(pc) {
  .title-p {
    display: none;
  }
}

</style>
